<template>
  <v-container fluid>

    <v-data-table v-model="selected" :loading="loading ? '#0482fb' : null" :headers="Avenantheaders" :items="statEcheance"
      item-key="name" items-per-page="5">
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Listing des avis échéance </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <!-- <v-switch
            v-model="showAllFil"
            label="Afficher toutes les données"
            color="#0482fb"
            @change="showAllFillData"
            class="pt-5"
          ></v-switch>
          <v-switch
            v-model="showYearFil"
            label="afficher les données de l'année "
            color="#0482fb"
            @change="showAllFillData"
            class="ml-10 pt-5"
          ></v-switch> -->
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-container fluid>
          <v-expansion-panels flat style="border: 1px solid #0482fb">
            <v-expansion-panel class="elevation-0">
              <v-expansion-panel-header>
                Tri / Recherche et importation vers excel ...
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="12" md="2">
                    <v-autocomplete outlined color="#0482fb" :items="userFile" class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" v-model="fileName" dense flat background-color="grey lighten-4"
                      label="Nom / Raison Sociale ...">
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-text-field outlined color="#0482fb" label="Numéro police ..." class="pt-5 pa-2"
                      prepend-inner-icon="mdi-magnify" dense v-model="policeNumber" flat
                      background-color="grey lighten-4"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="companyNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="company" flat background-color="grey lighten-4" label="compangnie"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="productNameList" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="product" flat background-color="grey lighten-4" label="Produit"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="monthRaprochement" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="monthValue" flat background-color="grey lighten-4" label="Mois d'échéance"></v-select>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-select outlined :items="yearArray" class="pt-5 pa-2" prepend-inner-icon="mdi-magnify" dense
                      v-model="yearValue" flat background-color="grey lighten-4" label="Année d'échéance"></v-select>
                  </v-col>
                </v-row>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="white--text mr-2" color="#0482fb" pill @click="onEnter">
                    <v-icon left>
                      mdi-magnify
                    </v-icon>
                    Appliquer la recherche
                  </v-btn>

                  <v-btn class="white--text pa-5" color="#1D6F42" :href="statFileEcheance" target="_blank">
                    <v-icon size="30" class="mr-8" color="#fff" left>
                      mdi-microsoft-excel
                    </v-icon>
                    Exporter vers un tableau EXCEL
                  </v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-container>
      </template>
      <template v-slot:item.dueDateMonth="{ item }">
        <td>
          <v-chip :color="getColor(item.dueDateMonth)" dark>
            {{ item.dueDateMonth }}
          </v-chip>
        </td>
      </template>
      <template v-slot:item.file="{ item }">
        {{ item.name  }}
      </template>
      <template v-slot:item.phone="{ item }">
        {{ item.phone }}
      </template>
      <template v-slot:item.email="{ item }">
        {{ item.email }}
      </template>
      <!-- <template v-slot:item.status="{ item }">
        {{
          item.followUpRenewals && item.followUpRenewals.status
          ? item.followUpRenewals.status
          : ""
        }}
      </template> -->
      <!--   <template v-slot:item.company="{ item }">
        <td>
          {{
            item.company && item.company.name ? item.company.name : item.company
          }}
        </td>
      </template>

      <template v-slot:item.followUpRenewals="{ item }">
        <td>
          <v-chip :color="getColor(item.followUpRenewals.status)" dark>
            {{ item.followUpRenewals ? item.followUpRenewals.status : "" }}
          </v-chip>
        </td>
      </template>

      <template v-slot:item.followUpRenewalsObservation="{ item }">
        {{
          item.followUpRenewals && item.followUpRenewals.observation
          ? item.followUpRenewals.observation
          : ""
        }}
      </template>


 
 -->
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { importDataExcel } from "../../exportDoc/index.js";
export default {
  name: "chartCall",
  data() {
    return {
      singleSelect: false,
      selected: [],
      productNameList: [],
      companyNameList: [],
      loading: false,
      monthRaprochement: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      yearArray: [],
      natureprospect: [
        "Renouvelé",
        "En cours",
        "Non renouvelé",
        "Perdu",
        "Non Renouvelable",
      ],
      Avenantheaders: [

        // {
        //   text: "Numéro dossier",
        //   align: "start",
        //   sortable: false,
        //   value: "policeNumber",
        // },
        { text: "Mois d'échéance", width: "200px", value: "dueDateMonth" },
        { text: "Status", width: "200px", value: "status" },
        { text: "Nom / Raison Sociale", width: "200px", value: "file" },
        { text: "Contact", width: "200px", value: "phone" },
        { text: "Mail", width: "200px", value: "email" },
        { text: "Prime nette", width: "200px", value: "netPrime" },
        { text: "Prime ttc", width: "200px", value: "totalPrime" },

        { text: "Branche", width: "200px", value: "product" },
        { text: "Compagnie", width: "200px", value: "company" },
        { text: "Numéro Police", width: "200px", value: "policeNumber" },
        { text: "Effet", width: "200px", value: "effectDate" },
        { text: "Echéance", width: "200px", value: "dueDate" },
        {
          text: "Observation",
          width: "200px",
          value: "Observation",
        },
      ],
      chartCoassurance: [],
      workSheetColumnName: [
        "Status",
        "Agent",
        "Numéro client",
        "Nom / Raison Sociale",
        "Contact",
        "Mail",
        "Compagnie",
        "Numéro police",
        "Branche",
        "Catégorie",
        "Effet",
        "Echéance",
        "Date de payement",
        "Date d'encaissement",
        "Type d'avenant",
        "Prime Nette",
        "Prime TTC",
        "Commission",
        "Date envoi avis",
        "Date envoi flotte (client)",
        "Date retour flotte (client)",
        "Date envoi flotte (Compagnie)",
        "Date retour flotte (Compagnie)",
        "Date envoi tableau garantie (client)",
        "Date retour tableau garantie (client)",
        "Date envoi tableau garantie (Compagnie)",
        "Date retour tableau garantie (Compagnie)",
        "Date demande projet (Compagnie)",
        "Date retour projet (Compagnie)",
        "Date demande mise à jour liste personnel",
        "Date retour mise à jour liste personnel",
        "Date de mise en place contrat",
        "Contrat payé",
        "Observation",
      ],
      workSheetName: "Statistique échéance",
      nombre: "échéance",
      users: [],
    };
  },
  mounted() {
    this.initStatCoass();
  },
  computed: {
    ...mapGetters([
      "statEcheance",
      "Companies",
      "Products",
      "statFileEcheance",
    ]),
  },
  watch: {
    statCall() { },
  },
  methods: {
    async makeSearchContract() {
      this.loading = true;
      try {
        await this.postSearchEcheance({
          fileName: this.fileName,
          product: this.product,
          policeNumber: this.policeNumber,
          actionType: this.actionType,
          company: this.company,

          withDeadlineNotice: true,
        });
      } catch (error) {
        console.log(error);
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les contrats")
        );
      }
      this.loading = false;
    },
    onEnter: function () {
      this.initStatCoass();
    },
    showAllFillData() {
      this.initStatCoass();
      //alert(this.showAllFil);
    },
    importData() {
      this.users = this.statEcheance;
      importDataExcel(
        this.workSheetColumnName,
        this.workSheetName,
        this.nombre,
        this.users
      );
    },
    ...mapActions([
      "getStateecheance",
      "getCompanies",
      "getProducts",
      "postSearchEcheance",
    ]),
    getColor(item) {
      if (item == "Janvier") return "#2a9d8f";
      else if (item == "Février") return "#e9c46a";
      else if (item == "Mars") return "#a8dadc";
      else if (item == "Avril") return "#e36414";
      else if (item == "Mai") return "#c8b6ff";
      else if (item == "Juin") return "#3a0ca3";
      else if (item == "Juillet") return "#edf6f9";
      else if (item == "Août") return "#80ed99";
      else if (item == "Septembre") return "#004e89";
      else if (item == "Octobre") return "#ff9770";
      else if (item == "Novembre") return "#720026";
      else if (item == "Décembre") return "#3da5d9";
      else return "green";
    },
    async YEARS() {
      // const years = []
      const d = new Date();
      let year = d.getFullYear();
      year = year - 10
      // alert(JSON.stringify(year - 10))
      for (let index = 0; index < 20; index++) {
        const element = year + index;
        // alert(element)
        this.yearArray.push(element)
      }
      // alert(JSON.stringify(this.yearArray))
    },
    async initStatCoass() {
      this.loading = true;
      try {
        await this.YEARS()
        await this.getStateecheance({
          fileName: this.fileName,
          policeNumber: this.policeNumber,
          product: this.product,
          company: this.company,
          monthValue: this.monthValue,
          yearValue: this.yearValue,
          // status: this.deadLineNoticeStatus,
          // periodStartDate: this.periodStartDate,
          // periodEndDate: this.periodEndDate,
          withoutPeriod: true,
          // currentYear: this.showYearFil,
        });

        await this.getProducts({ name: this.searchData });
        await this.getCompanies();
        this.companyNameList = defaultMethods.getNameList(this.Companies.docs);
        this.productNameList = defaultMethods.getNameList(this.Products.docs);
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
  },
};
</script>
